export default __webpack_public_path__ + "c1344ac9ae4dae564f279e3f4d07d404.svg";